<ion-item class="form-element-wrapper" fill="outline" mode="md">
  <ion-select [label]="label" label-placement="floating" [interface]="interface" [placeholder]="placeholder" [multiple]="multiple" [formControl]="formCtrl">
    <ion-select-option *ngFor="let option of options" [value]="option.value">
      {{ option.text }}
    </ion-select-option>
  </ion-select>
</ion-item>

<mom-validation-text [formCtrl]="formCtrl"></mom-validation-text>
